import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IAtgardWithUtbyte } from "~app/features/planera/model/IAtgard";

@Injectable({
    providedIn: "root"
})
export class AtgardService {
    private readonly apiClient = inject(ApiClientService);

    getAtgard(atgardGuid: string): Observable<IAtgardWithUtbyte> {
        return this.apiClient.get<IAtgardWithUtbyte>(`Planera/Atgard/${atgardGuid}`, true);
    }
}
